<template>
  <div class="login">
<!--    <div class="lang_tab">-->
<!--      <el-dropdown>-->
<!--        <span class="el-dropdown-link">-->
<!--          {{$t("lang")}} <i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
<!--        </span>-->
<!--        <el-dropdown-menu slot="dropdown">-->
<!--          <el-dropdown-item  @click.native="changeLanguage('en')">English</el-dropdown-item>-->
<!--          <el-dropdown-item  @click.native="changeLanguage('zh')">中文    </el-dropdown-item>-->
<!--        </el-dropdown-menu>-->
<!--      </el-dropdown>-->
<!--    </div>-->
    <div class="login_box">
      <template v-if="templateType == 'login'">
        <el-form  label-position="left" label-width="0px" @keyup.native.enter="handleClickLogin">
          <div class="login-container">
            <h3 class="login_title">登录账号</h3>
            <el-form-item>
              <el-input type="text" v-model="loginForm.email"    auto-complete="off" placeholder="请输入手机号/邮箱账号"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input type="password" v-model="loginForm.password"   auto-complete="off"  placeholder="请输入密码"></el-input>
            </el-form-item>
            <el-form-item>
              <el-link  @click="templateType = 'register'"  type="primary" :underline="false" style="margin-right: 20px">注册账号</el-link>
              <el-link  @click="templateType = 'forgot'"  type="primary" :underline="false">找回密码</el-link>
            </el-form-item>
            <div class="agree_check_wrap">
              <el-checkbox v-model="loginForm.agree"></el-checkbox>
              <span class="agreement_text">我已阅读并同意  <span @click="agreementShow=true" style="color: #1990ff;cursor: pointer">《隐私保护协议》</span></span>
            </div>
            <el-form-item style="width: 100%">
              <el-button   type="primary" style="width: 100%;" @keyup.enter="handleClickLogin" :loading="loading" @click="handleClickLogin"> {{$t("login_btn")}} </el-button>
            </el-form-item>
          </div>
        </el-form>
      </template>
      <template v-if="templateType == 'register'">
        <el-form  label-position="left" label-width="100px">
          <div class="register-container">
            <template v-if="registerType == '1'">
              <div class="return_link">
                <el-link type="primary" :underline="false" @click="handleClickRegisterReturn()">返回</el-link>
                <i class="el-icon-close"  @click="templateType = 'login'"></i>
              </div>
              <h3 class="login_title">注册账号</h3>
              <div class="register_tab">
                <el-tabs v-model="registerActive" @tab-click="handleClickRegisterType">
                  <el-tab-pane label="手机号注册" name="phone"></el-tab-pane>
                  <el-tab-pane label="邮箱注册" name="email"></el-tab-pane>
                </el-tabs>
              </div>
              <el-form-item v-if="registerActive == 'phone'" prop="phone" label="手机号">
                <el-input type="text" v-model="registerForm.phone" auto-complete="new-password" placeholder="请输入手机号"></el-input>
              </el-form-item>
              <el-form-item v-if="registerActive == 'phone'" prop="code" label="验证码">
                <el-input maxlength="6" placeholder="请输入验证码" v-model="registerForm.code"  auto-complete="new-password">
                  <el-button :disabled="getCodeBtnDisabled" @click="handleClickGetEmailCode('phone','register')"
                             slot="suffix"
                             type="text">
                    {{getCodeText}}
                  </el-button>
                </el-input>
              </el-form-item>
              <el-form-item v-if="registerActive == 'email'" prop="email" label="邮箱">
                <el-input type="text" v-model="registerForm.email" auto-complete="new-password" placeholder="请输入邮箱"></el-input>
              </el-form-item>
              <el-form-item v-if="registerActive == 'email'" prop="code" label="验证码">
                <el-input maxlength="6" placeholder="请输入验证码" v-model="registerForm.code"  auto-complete="new-password">
                  <el-button :disabled="getCodeBtnDisabled" @click="handleClickGetEmailCode('email','register')"
                             slot="suffix"
                             type="text">
                    {{getCodeText}}
                  </el-button>
                </el-input>
              </el-form-item>
              <el-form-item prop="email" label="密码">
                <el-input class="inputPassord" type="text" v-model="registerForm.password" auto-complete="new-password" placeholder="密码6-18位"></el-input>
              </el-form-item>
              <el-form-item prop="email" label="确认密码">
                <el-input  type="password" v-model="registerForm.repassword"  auto-complete="new-password" placeholder="请再次确认密码"></el-input>
              </el-form-item>
              <el-form-item prop="email" label="姓名">
                <el-input type="text" v-model="registerForm.name"  auto-complete="off" placeholder="请输入姓名"></el-input>
              </el-form-item>
              <el-form-item style="margin-top: 36px" label-width="0px">
                <el-button  type="primary" style="width: 100%;" @keyup.enter="handleClickRegister" :loading="loading"  @click="handleClickRegister">注册</el-button>
              </el-form-item>
            </template>

            <template v-if="registerType == '2'">
              <h3 class="login_title">注册账号</h3>

              <div class="prompt">
                账号{{registerForm.email}}注册成功
              </div>

              <el-button  type="primary" style="width: 100%;"  @click="templateType = 'login';registerType = '1';loginForm.email = registerForm.email">用此账号登录</el-button>
            </template>
          </div>
        </el-form>
      </template>
      <template v-if="templateType == 'forgot'">
        <el-form  label-position="left" label-width="100px">
          <div class="forgot-container">

            <template v-if="forgotType == '1'">
              <div class="return_link">
                <el-link type="primary" :underline="false"  @click="handleClickForgotReturn()">返回</el-link>
                <i class="el-icon-close"  @click="templateType = 'login'"></i>
              </div>
              <h3 class="login_title">找回密码</h3>
              <el-form-item prop="account" label="账号">
                <el-input type="text" v-model="forgotForm.account"  auto-complete="new-password" placeholder="请输入手机号/邮箱账号"></el-input>
              </el-form-item>
              <el-form-item prop="code" label="验证码">
                <el-input maxlength="6" placeholder="请输入验证码" v-model="forgotForm.code"  auto-complete="new-password">
                  <el-button :disabled="getCodeBtnDisabled" @click="handleClickGetEmailCode(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(forgotForm.account) ? 'email' :'phone','forget')"
                             slot="suffix"
                             type="text">
                    {{getCodeText}}
                  </el-button>
                </el-input>
              </el-form-item>

              <el-form-item style="margin-top: 36px" label-width="0px">
                <el-button  type="primary" style="width: 100%;" @keyup.enter="handleClickForgotNext" :loading="loading"  @click="handleClickForgotNext">下一步</el-button>
              </el-form-item>
            </template>


            <template v-if="forgotType == '2'">
              <div class="return_link">
                <el-link type="primary" :underline="false"  @click="forgotType = '1';forgotForm.password = '';forgotForm.repassword = ''">返回</el-link>
                <i class="el-icon-close"  @click="forgotType = '1'"></i>
              </div>
              <h3 class="login_title">重置密码</h3>
              <el-form-item prop="account" label="账号">
                <el-input type="text" v-model="forgotForm.account" disabled name="forgotEmail2" id="forgotEmail2" auto-complete="new-password" placeholder="请输入账号"></el-input>
              </el-form-item>
              <el-form-item prop="password" label="新密码">
                <el-input  type="password" v-model="forgotForm.password"  placeholder="密码6-18位" auto-complete="new-password"></el-input>
              </el-form-item>
              <el-form-item prop="repassword" label="确认密码">
                <el-input   type="password" v-model="forgotForm.repassword"   placeholder="请再次确认密码" auto-complete="new-password"></el-input>
              </el-form-item>

              <el-form-item style="margin-top: 36px" label-width="0px">
                <el-button  type="primary" style="width: 100%;" @keyup.enter="handleClickResetting" :loading="loading"  @click="handleClickResetting">确认重置</el-button>
              </el-form-item>
            </template>


            <template v-if="forgotType == '3'">
              <h3 class="login_title">找回密码</h3>
              <div class="prompt">
                账号{{forgotForm.account}}密码修改成功
              </div>
              <el-button  type="primary" style="width: 100%;"  @click="templateType = 'login';forgotType = '1';loginForm.email = registerForm.email">用此账号登录</el-button>
            </template>
          </div>
        </el-form>


      </template>
    </div>

    <el-dialog :visible="agreementShow"
               width="80%"
               @close="agreementShow=false"
               custom-class="agreement_dialog"
               title="隐私保护协议">
      <div class="agreement_wrap">
        <p>111</p>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { setup } from "@/locales";
import { sendMailCode ,sendPhoneCode, Login,register,resetPassword } from '@/api/api'
import { mapState } from 'vuex'
export default {
  name: 'login',

  data() {
    return {
      loginForm: {
        email: '',
        password: '',
        agree:false
      },
      registerForm: {
        name: '',
        password: '',
        repassword: '',
        email:'',
        phone:'',
        code:''
      },
      forgotForm: {
        account: '',
        code:'',
        password: '',
        repassword: '',
      },
      registerActive:'phone',
      loading: false,
      agreementShow:false,
      templateType:'login',
      forgotType:'1',
      registerType:'1',
      getCodeTime: 60,
      getCodeBtnDisabled: false,
    }
  },
  computed: {
    ...mapState(['webUserInfo']),
    getCodeText() {
      if (this.getCodeBtnDisabled) {
        return `${this.getCodeTime}秒后重新发送`;
      } else {
        return '获取验证码';
      }
    }
  },
  created () {
    if(this.webUserInfo && this.webUserInfo.token){
      this.$router.replace('/personal')
    }
  },
  methods: {
    // 切换注册方式
    handleClickRegisterType(value){

    },
    handleClickRegisterReturn(){
      this.templateType = 'login'
      this.registerForm = JSON.parse(JSON.stringify(this.$options.data().registerForm))
    },

    handleClickForgotReturn(){
      this.templateType = 'login'
      this.forgotForm = JSON.parse(JSON.stringify(this.$options.data().forgotForm))
    },
    // 获取验证码
    handleClickGetEmailCode(type,sendType){

      if(type == 'email'){
        let email = ''
        if(this.templateType == 'forgot'){
          email = this.forgotForm.account
        }else{
          email = this.registerForm.email
        }
        if(!email){
          this.$message.error('请输入邮箱账号')
          return false
        }
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailPattern.test(email)){
          this.$message.error('请输入有效的邮箱地址')
          return false
        }
        sendMailCode({
          email: email,
          type : sendType
        }).then(res => {
          if (res.code === 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: 'success',
              duration: 1500,
              onClose: () => { }
            });
            this.getCodeBtnDisabled = true;
            const timer = setInterval(() => {
              if (this.getCodeTime > 0) {
                this.getCodeTime--;
              } else {
                this.getCodeBtnDisabled = false;
                clearInterval(timer);
                this.getCodeTime = 60;
              }
            }, 1000);
          }
        })
      }else if(type == 'phone'){
        let phone = ''
        if(this.templateType == 'forgot'){
          phone = this.forgotForm.account
        }else{
          phone = this.registerForm.phone
        }
        if(!phone){
          this.$message.error('请输入手机号')
          return false
        }
        const phonePattern = /^1[3456789]\d{9}$/;
        if (!phonePattern.test(phone)){
          this.$message.error('请输入有效手机号')
          return false
        }

        sendPhoneCode({
          phone: phone,
          type : sendType
        }).then(res => {
          if (res.code === 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: 'success',
              duration: 1500,
              onClose: () => { }
            });
            this.getCodeBtnDisabled = true;
            const timer = setInterval(() => {
              if (this.getCodeTime > 0) {
                this.getCodeTime--;
              } else {
                this.getCodeBtnDisabled = false;
                clearInterval(timer);
                this.getCodeTime = 60;
              }
            }, 1000);
          }
        })
      }
    },
    // 登录
    handleClickLogin() {
      if (!this.loginForm.email) {
        this.$message.error('请输入账号');
        return false
      }
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const phonePattern = /^1[3456789]\d{9}$/;
      if (!emailPattern.test(this.loginForm.email) && !phonePattern.test(this.loginForm.email)){
        this.$message.error('请输入有效的账号')
        return false
      }
      if (!this.loginForm.password) {
        this.$message.error('请输入密码');
        return false
      }
      if(!this.loginForm.agree){
        this.$message.error('请勾选隐私保护协议');
        return false
      }
      let postData = {
        password: this.loginForm.password
      }
      if(emailPattern.test(this.loginForm.email)){postData.email = this.loginForm.email}
      if(phonePattern.test(this.loginForm.email)){postData.phone = this.loginForm.email}


      Login(postData).then(res => {
        if (res.code === 200) {
          let {data} = res
          this.loginSuccess(data)
        }
      })
    },
    //登录成功
    loginSuccess (res) {
      this.$message.success('登录成功')
      //保存token到vuex中
      this.$store.dispatch('saveWebUserInfo', res)
      //跳转
      this.$router.replace('/personal')
    },
    // 注册
    handleClickRegister(){
      if(this.registerActive == 'email'){
        if(!this.registerForm.email){
          this.$message.error('请输入邮箱账号');
          return false
        }
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailPattern.test(this.registerForm.email)){
          this.$message.error('请输入有效的邮箱账号')
          return false
        }
      }else if(this.registerActive == 'phone'){
        if(!this.registerForm.phone){
          this.$message.error('请输入手机号');
          return false
        }
        const phonePattern = /^1[3456789]\d{9}$/;
        if (!phonePattern.test(this.registerForm.phone)){
          this.$message.error('请输入有效手机号')
          return false
        }
      }

      if(!this.registerForm.code){
        this.$message.error('请输入验证码');
        return false
      }
      if(!this.registerForm.password){
        this.$message.error('请输入密码');
        return false
      }
      if(this.registerForm.password.length < 6 || this.registerForm.password.length>18 ){
        this.$message.error('密码长度需在6-18位');
        return false
      }
      if(this.registerForm.repassword != this.registerForm.password){
        this.$message.error('第二次输入的密码要与第一次一致');
        return false
      }
      if(!this.registerForm.name){
        this.$message.error('请输入姓名');
        return false
      }
      register({
        name:this.registerForm.name,
        password: this.registerForm.password,
        repassword: this.registerForm.repassword,
        email:this.registerForm.email,
        phone:this.registerForm.phone,
        code:this.registerForm.code,
      }).then(res => {
        if (res.code === 200) {
          let {data} = res
          this.$message({
            showClose: true,
            message: res.message,
            type: 'success',
            duration: 1500,
            onClose: () => { }
          });
          this.registerType = '2'
        }
      })

    },
    // 修改密码下一步
    handleClickForgotNext(){
      if(!this.forgotForm.account){
        this.$message.error('请输入账号');
        return false
      }
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const phonePattern = /^1[3456789]\d{9}$/;
      if (!emailPattern.test(this.forgotForm.account) && !phonePattern.test(this.forgotForm.account)){
        this.$message.error('请输入有效的账号')
        return false
      }
      if(!this.forgotForm.code){
        this.$message.error('请输入验证码');
        return false
      }
      this.forgotType = '2'
    },
    // 确认重置密码
    handleClickResetting(){
      if(!this.forgotForm.password){
        this.$message.error('请输入密码');
        return false
      }
      if(this.forgotForm.password.length < 6 || this.forgotForm.password.length>18 ){
        this.$message.error('密码长度需在6-18位');
        return false
      }
      if(this.forgotForm.repassword != this.forgotForm.password){
        this.$message.error('第二次输入的密码要与第一次一致');
        return false
      }
      resetPassword({
        account:this.forgotForm.account,
        code:this.forgotForm.code,
        password: this.forgotForm.password,
        repassword: this.forgotForm.repassword,
      }).then(res => {
        if (res.code === 200) {
          let {data} = res
          this.$message({
            showClose: true,
            message: res.message,
            type: 'success',
            duration: 1500,
            onClose: () => { }
          });
          this.forgotType = '3'
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: 'error',
            duration: 1500,
            onClose: () => { }
          });
        }
      })

    },
    // 切换语言
    changeLanguage(lang) {
      this.$i18n.locale = lang
      setup(lang);
      location.reload()
    }


  },
}
</script>

<style scoped lang="scss">
::v-deep .el-tabs__nav{
  width: 168px;
  margin: 0 auto;
  float: none;
}
.inputPassord {
  -webkit-text-security: disc;
}
.prompt{
  padding:100px 0;
  text-align: center;
  font-size: 18px;
  color: rgba(51, 51, 51, 1);
}
.login {
  width: 100%;
  height: 100vh;
  background-color: rgb(245 246 250);
  background-image: url(https://download.hecoos.com/enlightv/2024-32/Xw6yWsKhfWJ4pifpd4TQ.png);
  background-size: 100% 100%;
}

.login .login_box {
  width: 448px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0 auto;

  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  border-bottom: none;

}


.login .login_box .login_title {
  width: 100%;
  height: 48px;
  font-size: 24px;
  color: #333;
  line-height: 48px;
  margin-bottom: 22px;
  position: relative;
  font-weight: bold;
  text-align: center;
}
.agree_check_wrap {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.agree_check_wrap .agreement_text {
  line-height: 22px;
  font-size: 14px;
  color: #333333;
  transition: color .3s;
  margin-left: 4px;
}
.return_link{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.return_link i{
  cursor: pointer;
  font-size: 16px;
}

.login-container{
  padding: 40px;
}

.register-container{
  padding: 24px;
}

.forgot-container{
  padding: 24px;
}


</style>
